class ProductTabs extends HTMLElement {
    constructor() {
        super();
        this.activeButton = this.querySelector('.product-tabs__button.active');
        this.activeContent = this.querySelector('.product-tabs__content.active');
        this.buttons = this.querySelectorAll('.product-tabs__button');
    }

    connectedCallback() {
        this.buttons.forEach(btn => {
            btn.addEventListener('click', (e) => {
                const activeButton = e.currentTarget;
                const activeContent = this.querySelector(`#${e.target.dataset.id}`);

                this.changeActiveElement('button', activeButton);
                this.changeActiveElement('content', activeContent);
            })
        })
    }

    changeActiveElement(type, el) {
        const key = type === 'button' ? 'activeButton' : 'activeContent';

        this[key].classList.remove('active');
        this[key] = el;
        this[key].classList.add('active');
    }
}

if (!customElements.get('product-tabs')) {
    customElements.define('product-tabs', ProductTabs)
}
